import { useCurrentSiteTakeoverV2 } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import React from 'react'

interface Props {
  background: App.SiteTakeoverBackground
  className?: string
  vertical?: App.SiteTakeoverVertical
}

function SiteTakeoverBackgroundImage(props: Props) {
  const { className, background, vertical } = props

  const currentTakeover = useCurrentSiteTakeoverV2({ vertical })

  if (!currentTakeover) {
    return null
  }

  const Background = currentTakeover.backgroundElement

  return <Background
    className={className}
    background={background}
    imageId={currentTakeover.imageId}
  />
}

export default SiteTakeoverBackgroundImage
